




























































































































import {
  Component,
  Vue,
  Prop,
  PropSync,
  Ref,
} from "vue-property-decorator";
import {
  NotificationTemplateModel,
  NotificationTemplateTranslationModel,
  TemplateVariable,
} from "./types";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { Getter } from "vuex-class";
import { LanguageView } from "@/shared/models/languages";
import RichTextEditor from "@/components/misc/RichTextEditor.vue";
import NotificationTemplateVariables from "./NotificationTemplateVariables.vue";

@Component({
  components: {
    RightDrawer,
    RichTextEditor,
    NotificationTemplateVariables,
  },
})
export default class NotificationTemplateTranslations extends Vue {
  @Prop({ default: false }) open!: boolean;
  @Prop() variables?: TemplateVariable[];
  @PropSync("template")
  internalTemplate?: NotificationTemplateModel;

  @Getter("codebooks/languages")
  languages?: LanguageView[];

  variableFilter = "";

  get filteredVariables() {
    if (!this.variables) {
      return [];
    }
    if (!this.variableFilter) return this.variables;
    return this.variables.filter((x) => x.name.includes(this.variableFilter));
  }

  headers = [
    {
      text: "name",
      value: "name",
    },
  ];

  dragStart(e: DragEvent, data: any) {
    e.dataTransfer?.setData("text", data.name);
  }

  expandedTranslation = null as number | null;

  addTranslation() {
    this.internalTemplate?.translations?.push({
      id: 0,
      cultureCode: "",
      subject: this.internalTemplate.subject,
      body: this.internalTemplate.body,
    });
  }

  removeTranslation(translation: NotificationTemplateTranslationModel) {
    if (this.internalTemplate?.translations) {
      const index = this.internalTemplate.translations.findIndex(
        (x) => x == translation
      );
      if (index != -1) {
        this.internalTemplate.translations.splice(index, 1);
      }
    }
  }

  @Ref("drawer") rightDrawer?: RightDrawer;
  close() {
    this.$emit("update:open", false);
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      maxLength: (value: string, max: number) =>
        value.length <= max || this.$t("Validation.MaxLength", { count: max }),
    };
  }
}
